import { useState, useEffect } from 'react';
import { useTranslation } from '../../../shared/i18n';

const useProductPage = () => {
  const t = useTranslation();
  const [selectedPayment, setSelectedPayment] = useState('transferencia');

  const WHATSAPP_PHONE = '59895454544';

  // Analytics event hook - disparar al cargar la página
  useEffect(() => {
    onViewProduct();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Analytics: Vista del producto
  const onViewProduct = () => {
    console.log(`📊 Analytics Event: Product Viewed - ${t('conectados.title')}`);
    // Aquí se puede integrar con Google Analytics, Facebook Pixel, etc.
    // Example: gtag('event', 'view_item', { item_name: t('conectados.title') });
  };

  // Analytics: Click en WhatsApp
  const onClickWhatsApp = () => {
    console.log(`📊 Analytics Event: WhatsApp Click - ${t('conectados.title')}`, {
      payment_method: selectedPayment,
    });
    // Example: gtag('event', 'begin_checkout', { method: selectedPayment });
  };

  // Generar mensaje de WhatsApp según el método de pago seleccionado
  const getWhatsappMessage = () => {
    const paymentMethod = selectedPayment === 'mercadopago' 
      ? t('conecta2Product.price.mercadopago.label')
      : t('conecta2Product.price.transferencia.label');
    
    const message = t('conecta2Product.price.whatsappMessage.reserve').replace('{paymentMethod}', paymentMethod);
    return `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(message)}`;
  };

  // Mensaje alternativo para pedir información de métodos de pago
  const getPaymentInfoMessage = () => {
    const message = t('conecta2Product.price.whatsappMessage.paymentInfo');
    return `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(message)}`;
  };

  const handlePaymentSelect = (method) => {
    setSelectedPayment(method);
    console.log('💳 Payment method selected:', method);
  };

  return {
    selectedPayment,
    handlePaymentSelect,
    onClickWhatsApp,
    getWhatsappMessage,
    getPaymentInfoMessage,
  };
};

export default useProductPage;
